import EventSystem from "@/service/EventSystem";
import { StorageService } from "@/service/Storage";
import { log } from "@/utils/logger";

export const FONT_CDN = "https://interactive-web.la.spring-media.de/fonts";
export const FAVICON_CDN = "https://interactive-web.la.spring-media.de/favicon";
export const PRIVACY_STATEMENT_LINK_AS =
  "https://www.axelspringer.com/de/datenschutzerklaerung";

const storageService: StorageService = StorageService.instance();
const apiCookieName = "interactiveapi";
let canonicalUrl = "";

const config: IConfig = {
  version: "0.0.1",
  apiVersion: "v2",
  baseApi: "https://production.la.welt.de",
  baseApiNoCdn: "https://production-nocdn.la.welt.de",
  tealiumApi: "https://collect.tealiumiq.com",
  appNexusApi: "https://ib.adnxs.com/ttj",
};

interface HansIdConfig {
  postMethod: string;
  timeout: number;
}

/**
 * Get Interaction URL
 * @param noCdn {boolean}
 */
export function getApiUrl(noCdn: boolean): string {
  let url: string = noCdn ? config.baseApiNoCdn : config.baseApi;

  if (storageService.hasCookie(apiCookieName)) {
    const host: string = storageService.getCookieValue(apiCookieName);
    if (host && host.length) {
      url = "https://" + host;
    }
    log.debug("Use following stage (API): " + url);
  }

  return url;
}

EventSystem.subscribe("canonical:received", (url: string): void => {
  canonicalUrl = url;
});

/**
 * Get document referrer URL
 */
export function getDocumentUrl(): string {
  if (canonicalUrl) {
    return canonicalUrl;
  }
  return parent !== window ? document.referrer : window.location.href;
}

/**
 * Get privacyLink
 * @param brand {string}
 */
export function getPrivacyLink(brand: string | undefined): string {
  if (brand === "bild") {
    return "https://www.bild.de/corporate-site/datenschutz/datenschutz/artikel-datenschutz-54485502.bild.html";
  }
  return "https://www.welt.de/datenschutz";
}

/**
 * Get hansIdSettings
 */
export function getHansIdSettings(): HansIdConfig {
  return {
    postMethod: "getHansId",
    timeout: 100,
  };
}

export default config;
